import * as React from 'react';

import styled from 'styled-components';

import { ISanityBlockContent } from '@rbi-ctg/menu';
import ActionButton, { ActionButtonVariants } from 'components/action-button';
import AccountLayout from 'components/layout/account';
import SanityBlockRenderer from 'components/sanity-block-renderer';

const ButtonContainer = styled.div`
  margin: 32px auto 0;
  width: 90%;

  ${Styles.desktop`
    width: 80%;
  `}

  & > :last-child {
    margin-top: 32px;
  }
`;

const ConfirmButton = styled(ActionButton)`
  font-size: 1.25rem;

  color: ${Styles.color.error};
  border-color: ${Styles.color.error};

  :hover {
    color: ${Styles.color.error};
    border-color: ${Styles.color.error};
  }

  &[disabled] {
    background-color: ${Styles.color.white};
    border-color: ${Styles.color.error};
  }
`;

const CancelButton = styled(ActionButton)`
  font-size: 1.25rem;

  color: ${Styles.color.grey.two};
  border-color: ${Styles.color.grey.two};

  :hover {
    color: ${Styles.color.grey.two};
    border-color: ${Styles.color.grey.two};
  }
`;

const Error = styled.p<{ visibility: string }>`
  font-size: 1.25rem;
  color: ${Styles.color.error};
  text-align: center;

  visibility: ${p => p.visibility};
`;

export interface IPageContentProps {
  headerText?: string | null;
  content?: ISanityBlockContent[] | null;
  accountDeleteButtonText?: string | null;
  cancelButtonText?: string | null;
  onAccountDelete(): void;
  onCancel(): void;
  isLoading: boolean;
  isRejected: boolean;
  errorText?: string | null;
}

export const PageContent: React.FC<IPageContentProps> = ({
  headerText,
  content,
  accountDeleteButtonText,
  cancelButtonText,
  onAccountDelete,
  onCancel,
  isLoading,
  isRejected,
  errorText
}) => {
  return (
    <AccountLayout header={headerText}>
      <SanityBlockRenderer content={content} />
      <ButtonContainer>
        <CancelButton variant={ActionButtonVariants.OUTLINE} onClick={onCancel} fullWidth>
          {cancelButtonText}
        </CancelButton>
        <ConfirmButton
          variant={ActionButtonVariants.OUTLINE}
          onClick={onAccountDelete}
          isLoading={isLoading}
          loadingColor={Styles.color.error}
          fullWidth
        >
          {accountDeleteButtonText}
        </ConfirmButton>
      </ButtonContainer>
      <Error visibility={isRejected ? 'visible' : 'hidden'}>{errorText}</Error>
    </AccountLayout>
  );
};
